
import React from "react";
import HeaderWithBackButton from "@/components/common/HeaderWithBackButton";

interface ProfileHeaderProps {
  title: string;
  subtitle?: string;
}

const ProfileHeader = ({ title, subtitle }: ProfileHeaderProps) => {
  return (
    <HeaderWithBackButton title={title} subtitle={subtitle} backLabel="Back" backTo={-1} />
  );
};

export default ProfileHeader;
